import React, { useRef, useState } from "react";
import {
  Grid,
  IconButton,
  Switch,
  Box,
  Button as MuiButton,
  Tooltip,
  FormControl,
  FormGroup,
  FormControlLabel,
  MenuItem,
  Radio,
  Checkbox,
} from "@mui/material";
import { Button } from "antd";
import { message } from "antd";
import { CALL_API } from "common/API";
import { CustomTextField } from "common/common";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { selectFormQuestions, formQuestions } from "./formSlice";
import FormOptions from "./options";
import { CustomIconButton } from "../../common/common";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Select, Divider } from "antd";
import { useTranslation } from "react-i18next";

const { Option } = Select;

const optionLabelStyle = {
  textTransform: "none",
  color: "#C9C9C9",
  fontWeight: 400,
};

function EachFormSection({
  fullFormDetail,
  setFullFormDetail,
  formbasicDetail,
  setSavedForm,
  pageView,
  selectedItem,
  setPageView,
  fetchData,
  isFormBuilder = false,
  addEditFormBuilder,
  access = true,
}) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const containerRef = useRef(null);

  let history = useHistory();
  const createdQuestions = useAppSelector(selectFormQuestions);

  const [loading, setLoading] = useState(false);
  const [additionalFormOption, setAdditionalFormOption] = useState(null);

  const handleAdditionalFormClick = (event) => {
    setAdditionalFormOption(event.currentTarget);
  };

  const handleAdditionalFormClose = () => {
    setAdditionalFormOption(null);
  };

  React.useEffect(() => {
    if (fullFormDetail?.length === 0) {
      setFullFormDetail([
        {
          question: "",
          question_placeholder: "Question",
          options: [{ optionText: "Option 1", placeholder: "Option 1" }],
          formType: "MULIPLE_CHOICE",
          id: 1,
          requiredSwitch: false,
        },
      ]);
    }
  }, []);

  React.useEffect(() => {
    const autoSaveForm = fullFormDetail;
    dispatch(formQuestions(autoSaveForm));
  }, [fullFormDetail]);

  const handleQuestionValue = (text, i) => {
    var questionText = [...fullFormDetail];
    questionText[i].question = text;
    setFullFormDetail(questionText);
  };

  const addOption = (i) => {
    var addOptions = [...fullFormDetail];
    addOptions[i].options.push({
      optionText: "Option " + (addOptions[i].options.length + 1),
    });
    setFullFormDetail(addOptions);
  };

  const deleteQuestion = (i) => {
    let fullFormContent = [...fullFormDetail];
    fullFormContent.splice(i, 1);
    setFullFormDetail(fullFormContent);
  };

  const handleOptionValue = (text, i, optionindex) => {
    const optionValue = [...fullFormDetail];
    optionValue[i].options[optionindex].optionText = text;
    setFullFormDetail(optionValue);
  };

  const handleSeleteFormChange = (value, i) => {
    const optionType = [...fullFormDetail];
    optionType[i].formType = value;
    optionType[i].options = [{ optionText: "Option 1" }];
    setFullFormDetail(optionType);
  };

  const handleRequiredChange = (event, i) => {
    const requireQuestion = [...fullFormDetail];
    requireQuestion[i].requiredSwitch = event.target.checked;
    setFullFormDetail(requireQuestion);
  };

  const optionRemove = (i, optionindex) => {
    const questionOption = [...fullFormDetail];
    if (questionOption[i].options.length > 1) {
      questionOption[i].options.splice(optionindex, 1);
      setFullFormDetail(questionOption);
    }
  };

  const createDuplicate = (i) => {
    const copyForm = [...fullFormDetail];
    const newOptions = [];
    copyForm[i].options.forEach((opn) => {
      const opn1new = { optionText: opn?.optionText };
      newOptions.push(opn1new);
    });
    const newQuestion = {
      question: copyForm[i].question,
      options: newOptions,
      formType: copyForm[i].formType,
      id: fullFormDetail.length + 1,
      requiredSwitch: false,
    };
    setFullFormDetail((fullFormDetail) => [...fullFormDetail, newQuestion]);
  };

  const addExtraForm = () => {
    setFullFormDetail((fullFormDetail) => [
      ...fullFormDetail,
      {
        question: "",
        question_placeholder: "Question",
        options: [{ optionText: "Option 1" }],
        formType: "MULIPLE_CHOICE",
        id: fullFormDetail.length + 1,
        requiredSwitch: false,
      },
    ]);
  };

  const saveForm = async () => {
    if (formbasicDetail.title && formbasicDetail.description) {
      setLoading(true);
      const combinedData = { ...formbasicDetail, questions: fullFormDetail };
      const { code } = await CALL_API(`appraisalform`, "post", combinedData);
      if (code === "SUCCESS") {
        setSavedForm(true);
        history.push("/appraisal");
        message.success(t("Form created successfully"));
      }
      setLoading(false);
    } else {
      message.error(t("Empty Title and Description can't be saved"));
    }
  };

  const updateForm = async (id) => {
    if (formbasicDetail.title !== 0 && formbasicDetail.description !== 0) {
      setSavedForm(true);
      const combinedData = { ...formbasicDetail, questions: fullFormDetail };
      const { code } = await CALL_API(
        `appraisalform/${id}`,
        "patch",
        combinedData
      );
      if (code === "SUCCESS") {
        fetchData();
        setPageView(false);
        message.success(t("Appraisal Updated successfully"));
      }
    } else {
      message.error(t("Empty Question can't be saved"));
    }
  };

  const onSubmit = () => {
    console.log("isFormBuilder --->", isFormBuilder);
    if (isFormBuilder) {
      const combinedData = { ...formbasicDetail, questions: fullFormDetail };
      return addEditFormBuilder(combinedData, selectedItem?.formBuilderId);
    } else if (pageView === "edit") {
      updateForm(selectedItem.appraisalFormId);
    } else {
      saveForm();
    }
  };

  const shuffleOptions = async (i) => {
    var fullOption = [...fullFormDetail];
    await fullOption[i].options.sort(() => 0.5 - Math.random());
    setFullFormDetail(fullOption);
    handleAdditionalFormClose();
  };

  return (
    <React.Fragment>
      {fullFormDetail?.map((form, i) => {
        return (
          <>
            <div className="mt-3 bg_light rounded-2">
              <Box className="pt-3">
                <div className="px-4">
                  <Grid container>
                    <Grid item md={8} sm={11} xs={11}>
                      <Box sx={{ pb: 2 }}>
                        <CustomTextField
                          className="mt-3 fw-bold"
                          id="standard-basic1"
                          variant="standard"
                          value={form?.question || ""}
                          placeholder={form?.question_placeholder}
                          onChange={(e) =>
                            handleQuestionValue(e.target.value, i)
                          }
                          fullWidth
                          multiline
                        />
                      </Box>
                    </Grid>
                    <Grid item md={1} sm={1} xs={1}>
                      {form?.requiredSwitch && (
                        <Box className="text-danger fw-bold">*</Box>
                      )}
                    </Grid>
                    <Grid item md={3} sm={12} xs={12} ref={containerRef}>
                      <Select
                        id={`simple-select-filled${form.id}`}
                        value={form.formType || "MULIPLE_CHOICE"}
                        onChange={(value) => handleSeleteFormChange(value, i)}
                        style={{ width: "100%", borderRadius: "5px" }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                      >
                        <Option value="SHORT_ANS">{t("Short answer")}</Option>
                        <Option value="PARAGRAPH">{t("Paragraph")}</Option>
                        <Option value="MULIPLE_CHOICE">
                          {t("Multiple Choice")}
                        </Option>
                        <Option value="CHECKBOX">{t("Checkboxes")}</Option>
                        <Option value="DROPDOWN">{t("Dropdown")}</Option>
                        <Option value="DATE">{t("Date")}</Option>
                        <Option value="TIME">{t("Time")}</Option>
                      </Select>
                    </Grid>
                  </Grid>

                  <FormOptions
                    form={form}
                    i={i}
                    handleOptionValue={handleOptionValue}
                    optionRemove={optionRemove}
                  />

                  <Grid container>
                    <Grid item lg={12}>
                      {fullFormDetail[i]?.formType === "MULIPLE_CHOICE" && (
                        <>
                          <Radio disabled key={`radio-disbaled-${i}`} />
                          <MuiButton
                            size="small"
                            onClick={() => addOption(i)}
                            style={optionLabelStyle}
                          >
                            {t("Add Option")}
                          </MuiButton>
                        </>
                      )}

                      {fullFormDetail[i]?.formType === "CHECKBOX" && (
                        <>
                          <Checkbox disabled key={`check-disbaled-${i}`} />
                          <MuiButton
                            size="small"
                            onClick={() => addOption(i)}
                            style={optionLabelStyle}
                          >
                            {t("Add Option")}
                          </MuiButton>
                        </>
                      )}

                      {fullFormDetail[i]?.formType === "DROPDOWN" && (
                        <>
                          <MuiButton
                            size="small"
                            onClick={() => addOption(i)}
                            style={optionLabelStyle}
                          >
                            {t("Add Option")}
                          </MuiButton>
                        </>
                      )}
                    </Grid>
                  </Grid>
                </div>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    p: "5px 15px",
                    borderTop: 1,
                    borderColor: "divider",
                    backgroundColor: "#F8F8F8",
                  }}
                >
                  <Tooltip title={t("Duplicate")}>
                    <IconButton onClick={() => createDuplicate(i)}>
                      <ContentCopyOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                  <Box
                    sx={{
                      borderRight: 1,
                      borderColor: "rgba(0, 0, 0, 0.12)",
                      pl: "10px",
                    }}
                  >
                    <Tooltip title={t("Delete")}>
                      <CustomIconButton
                        onClick={() => deleteQuestion(i)}
                        className="mx-2"
                      >
                        <DeleteOutlinedIcon />
                      </CustomIconButton>
                    </Tooltip>
                  </Box>
                  <FormGroup aria-label="position" row>
                    <FormControlLabel
                      value="start"
                      control={
                        <Switch
                          style={{ color: "#2D53DA" }}
                          checked={form.requiredSwitch || false}
                          onChange={(event) => handleRequiredChange(event, i)}
                        />
                      }
                      label={t("Required")}
                      labelPlacement="start"
                    />
                  </FormGroup>
                </Box>
              </Box>
            </div>
          </>
        );
      })}

      <Box className="mt-3 pb-4">
        <div className="text-center">
          <Button
            className="btn-style rounded-2"
            type="primary"
            onClick={addExtraForm}
          >
            <AddIcon className="pb-1" />
          </Button>
        </div>
        <div className="text-end mt-3">
          {access && (
            <Button
              className="btn-style"
              type="primary"
              onClick={onSubmit}
              loading={loading}
            >
              {pageView === "edit" ? t("Update") : t("Create")}
            </Button>
          )}
        </div>
      </Box>
    </React.Fragment>
  );
}

export default EachFormSection;
